// extracted by mini-css-extract-plugin
module.exports = {"listStyle":"_12g02Wk5x8JGzz2lMUsIX_"};